import {VStack} from "@chakra-ui/react";

const DetailCard = ({ children, ...props }) => {

  return (
    <VStack boxShadow='base' w={'100%'} fontSize={'sm'}
            p={6} py={7} borderRadius={'lg'}
            mt={8}
            spacing={7}
            bg={'white'}
            alignItems={"flex-start"} columns={2} justifyContent={'space-between'}
            {...props}
    >
      {children}
    </VStack>
  )
}

export default DetailCard
